import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import HideTagsPlugin from "./components/hideTagsPlugin";

const App = () => {
  return <SwaggerUI
      url="/documentation/getSwaggerYaml"
      docExpansion={"none"}
      plugins={[HideTagsPlugin(['Admin'])]}
      filter
  />;
};

export default App;
